import { render, staticRenderFns } from "./CreateReward.vue?vue&type=template&id=d2418afa&scoped=true"
import script from "./CreateReward.vue?vue&type=script&lang=js"
export * from "./CreateReward.vue?vue&type=script&lang=js"
import style0 from "./CreateReward.vue?vue&type=style&index=0&id=d2418afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2418afa",
  null
  
)

export default component.exports